module.exports = __webpack_public_path__ + "img/checked.d2bbfcf5.svg";